import React from "react";
import { Box, Typography, IconButton } from "@mui/joy";
import { ChevronLeft, ChevronRight } from "lucide-react";
import moment from "moment";

export default function CalendarWidget() {
    const today = moment();
    const startOfMonth = moment().startOf('month');
    const endOfMonth = moment().endOf('month');
    
    // Create matrix for days
    const days = [];
    let curDay = startOfMonth.clone().startOf('week');
    
    while (curDay.isBefore(endOfMonth) || curDay.isSame(endOfMonth, 'week')) {
        days.push(curDay.clone());
        curDay.add(1, 'day');
    }

    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    return (
        <Box 
            p={3} 
            sx={{ 
                bgcolor: "background.surface",
                borderRadius: "xl",
                boxShadow: "sm",
                border: "none",
            }}
        >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box>
                    <Typography level="h3" sx={{ fontWeight: 800, fontSize: "1.4rem" }}>
                        {today.format("MMM, DD")} <Typography sx={{ color: "text.tertiary", fontWeight: 500 }}>{today.format("dddd")}</Typography>
                    </Typography>
                </Box>
                <Box display="flex" gap={1}>
                    <IconButton size="sm" variant="plain"><ChevronLeft size={18} /></IconButton>
                    <IconButton size="sm" variant="plain"><ChevronRight size={18} /></IconButton>
                </Box>
            </Box>

            <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1} mb={1}>
                {weekdays.map(d => (
                    <Typography key={d} level="body-xs" sx={{ textAlign: "center", fontWeight: 600, color: "text.tertiary" }}>
                        {d}
                    </Typography>
                ))}
            </Box>
            
            <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={1}>
                {days.map((d, i) => {
                    const isToday = d.isSame(today, 'day');
                    const isCurrentMonth = d.month() === today.month();
                    
                    return (
                        <Box
                            key={i}
                            sx={{
                                aspectRatio: "1/1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                color: isToday ? "#fff" : isCurrentMonth ? "text.primary" : "text.tertiary",
                                bgcolor: isToday ? "#124b30" : "transparent",
                                fontWeight: isToday ? 800 : 500,
                                fontSize: "0.9rem",
                                cursor: "pointer",
                                "&:hover": {
                                    bgcolor: isToday ? "#124b30" : "rgba(0,0,0,0.04)"
                                }
                            }}
                        >
                            {d.date()}
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
